import React from 'react';

export function CheckedIcon() {
  return (
    <svg
      width="11"
      height="9"
      viewBox="0 0 11 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2666 4.00016L4.11105 6.66683L9.79994 1.3335"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function KeyIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.63116 10.4996C10.2143 11.3485 10.5556 12.3765 10.5556 13.4843C10.5556 16.3991 8.19261 18.762 5.27778 18.762C2.36294 18.762 0 16.3991 0 13.4843C0 10.5694 2.36294 8.20649 5.27778 8.20649C6.54383 8.20649 7.70577 8.65228 8.61518 9.39545L15.0844 2.9262L17.041 0.96967C17.3339 0.676777 17.8087 0.676777 18.1016 0.96967C18.3945 1.26256 18.3945 1.73744 18.1016 2.03033L16.6993 3.43268L18.7148 5.27836C18.8658 5.41656 18.9537 5.61042 18.9582 5.815C18.9627 6.01958 18.8834 6.21712 18.7387 6.36182L15.572 9.52849C15.2912 9.80928 14.8402 9.82254 14.5434 9.55871L12.4415 7.6904L9.65718 10.4748C9.64865 10.4833 9.63998 10.4916 9.63116 10.4996ZM15.0114 7.96777L13.504 6.62791L15.6376 4.49437L17.1238 5.85534L15.0114 7.96777ZM9.05556 13.4843C9.05556 15.5707 7.36419 17.262 5.27778 17.262C3.19137 17.262 1.5 15.5707 1.5 13.4843C1.5 11.3979 3.19137 9.70649 5.27778 9.70649C7.36419 9.70649 9.05556 11.3979 9.05556 13.4843Z"
        fill="currentColor"
      />
    </svg>
  );
}
